import rechargeApi from "@/request/recharge";
import url from "postcss-url";

const urls = {
  // 充值相关
  unifiedOrderUrl: "/order/unifiedOrder",
  getProductUrls:"/order/loadProductConfigs",
  getServerUrls:"/server/v1/loadServerList",
  getQueryRoles:"/order/queryRoles",


  // getResultByCode: "/backend/api/wechatPay/getResultByCode",
  // getWeChatPayServer: "/backend/api/publicsrc/getWeChatPayServer",
};

const recharApi = {
    // 充值相关
    unifiedOrder: (params) => {

      return rechargeApi({ 
        url: urls.unifiedOrderUrl,
         method: "post", 
         data:params});
    },
    getServerUrls: () => {
      return rechargeApi({ 
        url: urls.getServerUrls, 
        method: "post", 
       
      });
    },
    getProductUrls: (params) => {
      return rechargeApi({ 
        url: urls.getProductUrls, 
        method: "post", 
        data:params
      });
    },
    getQueryRoles: (params) => {
      return rechargeApi({ 
        url: urls.getQueryRoles, 
        method: "post", 
        data:params
      });
    },
  
    // getResultByCode: (params) => {
    //   return request({ url: urls.getResultByCode, method: "get", params: { ...params } });
    // },
    // getWeChatPayServer: () => {
    //   return request({ url: urls.getWeChatPayServer, method: "get" });
    // },
};

export default recharApi;
